import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";

import BusinessTemplate from "./ui/BusinessTemplate";
import StripeConnectDetailsPanel from "./ui/StripeConnectDetailsPanel";
import StripeIncompleteWarning from "./ui/StripeIncompleteWarning";
import YourLinkedBankAccount from "./ui/YourLinkedBankAccount";

export default function Payment() {
  const { organisation } = useOrganisationContext();

  const missingRequirements = organisation?.missingRequirements || [];
  const isIncomplete = organisation?.onboardingStatus !== "complete" || missingRequirements.length > 0;

  if (isIncomplete) {
    return (
      <BusinessTemplate active="payment">
        <PartnerDashboardBox gap={0} borderRadius={20} maxWidth={1007}>
          <StripeIncompleteWarning.Header />
          <StripeIncompleteWarning.Body missingRequirements={missingRequirements} />
        </PartnerDashboardBox>
      </BusinessTemplate>
    );
  }

  return (
    <BusinessTemplate active="payment">
      <PartnerDashboardBox>
        <YourLinkedBankAccount missingRequirements={missingRequirements} />
      </PartnerDashboardBox>
      <PartnerDashboardBox>
        <StripeConnectDetailsPanel />
      </PartnerDashboardBox>
    </BusinessTemplate>
  );
}
